export enum Component {
  INPUT = "INPUT",
  DATE = "DATE",
  NUMBER = "NUMBER",
  WEEK = "WEEK",
}
